import { EffectsMapObject } from "dva";
import { ReducersMapObject } from "redux";
import { freeze } from "immer";
import { CoreEffects, CoreState, CoreReducers, formatDate, pictureService } from "@reco-m/core";
import { app, arrToTree } from "@reco-w/core-ui";
import { tagService } from "@reco-m/tag-service";

import { Namespaces as commonNamespaces } from "@reco-w/common-models";
import { IParkBindTableNameEnum } from "@reco-w/common-common";
import { authAccountHttpService, personInfoService } from "@reco-w/auth-service";

import { Namespaces } from "./common";

export namespace accountEditModel {
    export const namespace = Namespaces.accountEdit;

    export const state: any = freeze({ ...CoreState, showloading: true }, !0);
    export type StateType = typeof state;
    export const reducers: ReducersMapObject = {
        ...CoreReducers,
        initState() {
            return state;
        },
    };
    export const effects: EffectsMapObject = {
        ...CoreEffects,
        /**
         * 初始化页面
         * @param { message }
         * @param { call, put }
         */
        *initPage({ message }, { call, put }) {
            try {
                yield put({ type: "initState" });
                yield put({ type: "getUserInfo", message });
                // yield put({ type: "getTags", message });
            } catch (e) {
                yield call(message!.error, "initPage：" + e.errmsg);
            }
        },
        /**
         * 提交保存用户信息
         * @param { message }
         * @param { call, select }
         */
        *savePersonInfo({ message }, { call, select }) {
            try {
                const { birthday, email, nickName, mobile, gender, currentUser, ...props } = yield select((state) => state[Namespaces.accountEdit]);
                delete props.isLoading;
                delete props.showloading;
                const accountEdit = yield select((state) => state[Namespaces.accountEdit]);
                yield call(authAccountHttpService.put, currentUser.id, {
                    account: {
                        ...currentUser,
                        mobile: mobile,
                        nickName: nickName,
                        gender: gender,
                        birthday: formatDate(birthday),
                        email: email,
                        realName: accountEdit!.realName,
                        password: undefined,
                    },
                });
            } catch (e) {
                yield call(message!.error, e.errmsg);
            }
        },
        /**
         * 提交修改联系人信息
         * @param { message }
         * @param { call, select }
         */
        *savePersonal({ message }, { call, select }) {
            try {
                const state = yield select((state) => state[Namespaces.accountEdit]),
                    personInfo = state!.personInfo,
                    interestsValueArr = state!.interestsValueArr,
                    tagClass = state!.tagClass,
                    InterestsTags = tagClass && tagClass["ACCOUNT/xingqah"],
                    politicalStatus = state!.politicalStatus,
                    highestEducation = state!.highestEducation,
                    professionalTitle = state!.professionalTitle,
                    majorField = state!.majorField,
                    homeTownValue = state!.homeTownValue,
                    hometownTags = tagClass && tagClass["ACCOUNT/jiax"];

                let interests =
                    (interestsValueArr &&
                        interestsValueArr.length > 0 &&
                        InterestsTags &&
                        InterestsTags.length > 0 &&
                        InterestsTags.filter((x) => interestsValueArr.contains(x.tagValue))) ||
                    [];
                let interestName = (interests.length > 0 && interests.map((x) => x.tagName)) || [];
                let interestValue = (interests.length > 0 && interests.map((x) => x.tagValue)) || [];

                let hometown =
                    (homeTownValue && homeTownValue.length > 0 && hometownTags && hometownTags.length > 0 && hometownTags.filter((x) => homeTownValue.contains(x.tagValue))) || [];
                let province = hometown.length > 0 && hometown.find((x) => x.layer === 0);
                let city = hometown.length > 0 && hometown.find((x) => x.layer === 1);
                let district = hometown.length > 0 && hometown.find((x) => x.layer === 2);
                const data = {
                    bindTableName: "sys_account",
                    bindTableId: state!.userId,
                    fullName: state!.realName,
                    idiograph: state!.idiotGraph || "",
                    interest: (interestName?.length > 0 && interestName.join(",")) || "",
                    interestValue: (interestValue?.length > 0 && interestValue.join(",")) || "",
                    province: province?.tagName || "",
                    provinceValue: province?.tagValue || "",
                    city: city?.tagName || "",
                    cityValue: city?.tagValue || "",
                    district: district?.tagName || "",
                    districtValue: district?.tagValue || "",
                    politicalStatus: politicalStatus?.tagName,
                    politicalStatusValue: politicalStatus?.tagValue,
                    highestEducation: highestEducation?.tagName,
                    highestEducationValue: highestEducation?.tagValue,
                    jobTitle: professionalTitle?.tagName,
                    jobTitleValue: professionalTitle?.tagValue,
                    researchArea: majorField?.tagName,
                    researchAreaValue: majorField?.tagValue,
                };
                if (!personInfo) {
                    yield call(personInfoService.saveInfo, data);
                } else {
                    yield call(personInfoService.modifyInfo, personInfo.id, data);
                }
            } catch (e) {
                yield call(message!.error, "savePerson" + e.errmsg);
            }
        },
        /**
         * 提交修改
         * @param { message, callback }
         * @param { put, call, select }
         */
        *saveData({ message, callback }, { put, call, select }) {
            try {
                const { currentUser } = yield select((state) => state[Namespaces.accountEdit]);
                yield put({ type: "showLoading" });
                yield put({ type: "input", data: { isSubmit: true } });

                yield yield put({ type: "savePersonInfo", message });
                yield yield put({ type: "savePersonal", message });
                yield yield put({ type: `${commonNamespaces.memberCommon}/cleanMemberInfo` });
                yield yield put({ type: `${commonNamespaces.memberCommon}/refreshCurrentUser` });
                const state = yield select((state) => state[Namespaces.accountEdit]),
                    isSubmit = state!.isSubmit;
                if (callback && isSubmit) yield call(callback, currentUser.id);
            } catch (e) {
                yield call(message!.error, e.errmsg);
            } finally {
                yield put({ type: "hideLoading" });
                yield put({ type: "input", data: { isSubmit: false } });
            }
        },
        /**
         * 获取当前登录用户信息
         * @param {}
         * @param { select, put, call }
         */
        *getUserInfo({}, { select, put, call }) {
            try {
                yield put({ type: "showLoading" });
                yield yield put({ type: `${commonNamespaces.memberCommon}/getCurrentUser` });
                let memberCommonState: any = yield select((state) => state[commonNamespaces.memberCommon]),
                    user = memberCommonState.user;
                const currentUser = user.currentUser;
                let pictureSrc = yield call(pictureService.getPictureList, {
                    bindTableName: "sys_account",
                    bindTableId: currentUser.id,
                    customType: 1,
                });

                yield put({
                    type: "input",
                    data: {
                        currentUser,
                        userId: currentUser && currentUser.id,
                        thumb: pictureSrc ? pictureSrc[pictureSrc.length - 1] : "",
                        realName: currentUser && currentUser.realName,
                        hasRealName: currentUser && currentUser.realName ? true : false,
                        nickName: currentUser && currentUser.nickName,
                        mobile: currentUser && currentUser.mobile,
                        gender: currentUser && currentUser.gender,
                        email: currentUser && currentUser.email,
                        birthday: currentUser && currentUser.birthday,
                    },
                });
                yield put({ type: "getApplyTags", user });
                yield put({ type: "getOtherInfo", id: currentUser.id });
            } catch (message) {
            } finally {
                yield put({ type: "hideLoading" });
            }
        },
        /**
         * 查询联系人
         * @param { id }
         * @param { put, call }
         */
        *getOtherInfo({ id }, { put, call }) {
            try {
                const personInfo = yield call(personInfoService.getInfo, {
                    bindTableName: IParkBindTableNameEnum.account,
                    bindTableId: id,
                });

                let jiax = [] as any;
                if (personInfo && personInfo.province) {
                    jiax.push(personInfo.provinceValue);
                    if (personInfo.city) {
                        jiax.push(personInfo.cityValue);
                    }
                }

                yield put({
                    type: "input",
                    data: {
                        personInfo,
                        idiotGraph: personInfo.idiograph,
                        homeTownValue: jiax,
                        politicalStatus: { tagName: personInfo.politicalStatus, tagValue: personInfo.politicalStatusValue },
                        highestEducation: { tagName: personInfo.highestEducation, tagValue: personInfo.highestEducationValue },
                        majorField: { tagName: personInfo.researchArea, tagValue: personInfo.researchAreaValue },
                        professionalTitle: { tagName: personInfo.jobTitle, tagValue: personInfo.jobTitleValue },
                        interestsValueArr: personInfo && personInfo.interestValue ? personInfo.interestValue.split(",") : [],
                    },
                });
            } catch (message) {
            } finally {
                yield put({ type: "hideLoading" });
            }
        },
        /**
         * 获取用户信息标签列表
         * @param { message }
         * @param { put, call }
         */
        *getApplyTags({ message }, { put, call }) {
            try {
                const tags = yield call(tagService.getTagByTagClasses, {
                    tagClass: "ACCOUNT/guoj,ACCOUNT/minz,ACCOUNT/xuew,ACCOUNT/huny,ACCOUNT/jiax,ACCOUNT/xingqah,ACCOUNT/xuel,ACCOUNT/zhengzmm,ACCOUNT/zhic,ACCOUNT/zhuanyfx",
                });

                let hometownTags = tags["ACCOUNT/jiax"];
                if (hometownTags && hometownTags.length > 0) {
                    hometownTags = arrToTree(hometownTags);
                }

                yield put({
                    type: "input",
                    data: {
                        tagClass: tags,
                        hometownTags,
                    },
                });
            } catch (e) {
                yield call(message!.error, "getApplyTags：" + e.errmsg);
            }
        },
    };
}

app.model(accountEditModel);
